import React from 'react';
import { List as ListIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import Tile from '../../../../common/components/Tile/Tile';
import DateTimeFilter from '../../../../common/components/Filters/DateTimeFilter';
import TableEnhancedContainer from '../../../../common/components/TableEnhanced/TableEnhancedContainer';
import PermissionsCheck from '../../../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../../../common/constants/PermissionsEnum';
import Loading from '../../../../common/components/Loading/Loading';
import { withRouter } from '../../../../common/utils/NavigationWrapper';
import './LogBook.css';

const LogBookView = (props) => {
  return (
    <div>
      <PermissionsCheck permission={PermissionsEnum.VIEW_INSTRUMENT_LOGBOOK}>
        <div className="configuration__logbook">
          <DateTimeFilter
            dateTimeFromFilter={props.dateFrom}
            dateTimeToFilter={props.dateTo}
            maxDate={props.maxDate}
            onChangeDateTime={props.onChangeDateTime}
            onApplyFilters={props.onApplyFilters}
            isFetching={props.isFetching}
            metadata={props.metadata}
            dateTimeErrorMessage={props.dateTimeErrorMessage}
          />
        </div>
        <Loading condition={props.isFetching}>
          <Tile
            title="Instrument logbook"
            TitleIcon={ListIcon}
            helpTag="instrument_logbook-table"
            RightContent={
              <div>
                <Button
                  variant="contained"
                  data-qa="qa-addNewLog"
                  className="u-ml-double"
                  color="primary"
                  onClick={() => props.openAddLog()}
                >
                  Add
                </Button>
              </div>
            }
          >
            <TableEnhancedContainer
              {...props}
              className="InstrumentLogbookTable"
              enableHideColumns={true}
              enableActionButtons={true}
            />
          </Tile>
        </Loading>
      </PermissionsCheck>
    </div>
  );
};

export default withRouter(LogBookView);
